import { CmsPersonalDetailsForm } from './cms-personal-details-form.interface';
import { PersonalDetailsFormValue } from './personal-details-form-value.type';

export interface PersonalDetailsFormConfig {
  cmsData: CmsPersonalDetailsForm;
  groupCodes: string[];
  hasExistingSelectedQuotes: boolean;
  initialValue?: PersonalDetailsFormValue;
  privacyPolicy?: boolean;
}
